import React from 'react'
import './css/Footer.css'
import {Link} from 'react-router-dom'

export default _ => (
	<div id="footer">
		© 2010-{(new Date()).getFullYear()} Yasa Yener<br />
		<Link to="/imprint">Imprint</Link>
	</div>
)